module.exports = __webpack_public_path__ + "img/1541163264.2281d009.jpg";